export const PRACTICE_ROUNDS_BLOCKS_MOCK = [
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Ziggy9044',
        opponentScore: 7399,
        secrets: [
          {
            index: 0,
            value: 338277810,
          },
          {
            index: 1,
            value: 448930136,
          },
          {
            index: 2,
            value: 297119880,
          },
          {
            index: 3,
            value: 256988170,
          },
          {
            index: 4,
            value: 8977914,
          },
          {
            index: 5,
            value: 309631612,
          },
          {
            index: 6,
            value: 99229592,
          },
          {
            index: 7,
            value: 239189569,
          },
          {
            index: 8,
            value: 60567524,
          },
          {
            index: 9,
            value: 533076718,
          },
          {
            index: 10,
            value: 77786288,
          },
          {
            index: 11,
            value: 128729530,
          },
          {
            index: 12,
            value: 428840542,
          },
          {
            index: 13,
            value: 381281216,
          },
          {
            index: 14,
            value: 64187045,
          },
          {
            index: 15,
            value: 225863406,
          },
          {
            index: 16,
            value: 466032738,
          },
          {
            index: 17,
            value: 230969536,
          },
          {
            index: 18,
            value: 516681865,
          },
          {
            index: 19,
            value: 257936547,
          },
          {
            index: 20,
            value: 107435555,
          },
          {
            index: 21,
            value: 351395783,
          },
          {
            index: 22,
            value: 8417683,
          },
          {
            index: 23,
            value: 304212403,
          },
          {
            index: 24,
            value: 281775698,
          },
          {
            index: 25,
            value: 7484607,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Amenadiel Amenadiel',
        opponentScore: 5047,
        secrets: [
          {
            index: 0,
            value: 61968857,
          },
          {
            index: 1,
            value: 425232661,
          },
          {
            index: 2,
            value: 313233129,
          },
          {
            index: 3,
            value: 4812598,
          },
          {
            index: 4,
            value: 327494725,
          },
          {
            index: 5,
            value: 115759575,
          },
          {
            index: 6,
            value: 54572051,
          },
          {
            index: 7,
            value: 287946846,
          },
          {
            index: 8,
            value: 413996949,
          },
          {
            index: 9,
            value: 360221054,
          },
          {
            index: 10,
            value: 50826767,
          },
          {
            index: 11,
            value: 363141434,
          },
          {
            index: 12,
            value: 227840107,
          },
          {
            index: 13,
            value: 386693410,
          },
          {
            index: 14,
            value: 139414158,
          },
          {
            index: 15,
            value: 491901417,
          },
          {
            index: 16,
            value: 284980514,
          },
          {
            index: 17,
            value: 479127123,
          },
          {
            index: 18,
            value: 414331623,
          },
          {
            index: 19,
            value: 468461985,
          },
          {
            index: 20,
            value: 289352299,
          },
          {
            index: 21,
            value: 479799369,
          },
          {
            index: 22,
            value: 106757970,
          },
          {
            index: 23,
            value: 206702648,
          },
          {
            index: 24,
            value: 428728195,
          },
          {
            index: 25,
            value: 67592949,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'James Winfield',
        opponentScore: 6537,
        secrets: [
          {
            index: 0,
            value: 148178487,
          },
          {
            index: 1,
            value: 302290173,
          },
          {
            index: 2,
            value: 427074414,
          },
          {
            index: 3,
            value: 245844527,
          },
          {
            index: 4,
            value: 378603126,
          },
          {
            index: 5,
            value: 184421136,
          },
          {
            index: 6,
            value: 184273745,
          },
          {
            index: 7,
            value: 527484916,
          },
          {
            index: 8,
            value: 123531305,
          },
          {
            index: 9,
            value: 512496552,
          },
          {
            index: 10,
            value: 350600307,
          },
          {
            index: 11,
            value: 472274025,
          },
          {
            index: 12,
            value: 432975522,
          },
          {
            index: 13,
            value: 43727960,
          },
          {
            index: 14,
            value: 535507105,
          },
          {
            index: 15,
            value: 480844943,
          },
          {
            index: 16,
            value: 124286649,
          },
          {
            index: 17,
            value: 10582087,
          },
          {
            index: 18,
            value: 159045416,
          },
          {
            index: 19,
            value: 260876399,
          },
          {
            index: 20,
            value: 138976848,
          },
          {
            index: 21,
            value: 172109748,
          },
          {
            index: 22,
            value: 142837762,
          },
          {
            index: 23,
            value: 221101088,
          },
          {
            index: 24,
            value: 285289599,
          },
          {
            index: 25,
            value: 270076579,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'predator818',
        opponentScore: 13734,
        secrets: [
          {
            index: 0,
            value: 492387393,
          },
          {
            index: 1,
            value: 224928893,
          },
          {
            index: 2,
            value: 310204908,
          },
          {
            index: 3,
            value: 14161743,
          },
          {
            index: 4,
            value: 348828054,
          },
          {
            index: 5,
            value: 309914810,
          },
          {
            index: 6,
            value: 244521486,
          },
          {
            index: 7,
            value: 265525645,
          },
          {
            index: 8,
            value: 191086928,
          },
          {
            index: 9,
            value: 425383222,
          },
          {
            index: 10,
            value: 324375145,
          },
          {
            index: 11,
            value: 98488237,
          },
          {
            index: 12,
            value: 59354188,
          },
          {
            index: 13,
            value: 487910596,
          },
          {
            index: 14,
            value: 189499389,
          },
          {
            index: 15,
            value: 167561589,
          },
          {
            index: 16,
            value: 498631961,
          },
          {
            index: 17,
            value: 484495448,
          },
          {
            index: 18,
            value: 182441708,
          },
          {
            index: 19,
            value: 109787223,
          },
          {
            index: 20,
            value: 514189701,
          },
          {
            index: 21,
            value: 301054777,
          },
          {
            index: 22,
            value: 247271064,
          },
          {
            index: 23,
            value: 300287977,
          },
          {
            index: 24,
            value: 189036451,
          },
          {
            index: 25,
            value: 261520359,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'spencer alan Heywood',
        opponentScore: 6450,
        secrets: [
          {
            index: 0,
            value: 455679624,
          },
          {
            index: 1,
            value: 410577268,
          },
          {
            index: 2,
            value: 508372072,
          },
          {
            index: 3,
            value: 320692066,
          },
          {
            index: 4,
            value: 468332747,
          },
          {
            index: 5,
            value: 30387557,
          },
          {
            index: 6,
            value: 243979233,
          },
          {
            index: 7,
            value: 58839442,
          },
          {
            index: 8,
            value: 77782926,
          },
          {
            index: 9,
            value: 325000375,
          },
          {
            index: 10,
            value: 368463546,
          },
          {
            index: 11,
            value: 9351090,
          },
          {
            index: 12,
            value: 390677164,
          },
          {
            index: 13,
            value: 232521647,
          },
          {
            index: 14,
            value: 385192778,
          },
          {
            index: 15,
            value: 117188197,
          },
          {
            index: 16,
            value: 246524186,
          },
          {
            index: 17,
            value: 271237352,
          },
          {
            index: 18,
            value: 160200504,
          },
          {
            index: 19,
            value: 272590717,
          },
          {
            index: 20,
            value: 64076363,
          },
          {
            index: 21,
            value: 196538960,
          },
          {
            index: 22,
            value: 441546166,
          },
          {
            index: 23,
            value: 105747531,
          },
          {
            index: 24,
            value: 532314464,
          },
          {
            index: 25,
            value: 345190405,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Kendrab23',
        opponentScore: 8952,
        secrets: [
          {
            index: 0,
            value: 95584993,
          },
          {
            index: 1,
            value: 407859644,
          },
          {
            index: 2,
            value: 347905634,
          },
          {
            index: 3,
            value: 191726795,
          },
          {
            index: 4,
            value: 516102442,
          },
          {
            index: 5,
            value: 193352771,
          },
          {
            index: 6,
            value: 201701543,
          },
          {
            index: 7,
            value: 512147152,
          },
          {
            index: 8,
            value: 194772519,
          },
          {
            index: 9,
            value: 96407327,
          },
          {
            index: 10,
            value: 77159240,
          },
          {
            index: 11,
            value: 362805862,
          },
          {
            index: 12,
            value: 47646017,
          },
          {
            index: 13,
            value: 93950793,
          },
          {
            index: 14,
            value: 230357628,
          },
          {
            index: 15,
            value: 160603062,
          },
          {
            index: 16,
            value: 139227592,
          },
          {
            index: 17,
            value: 190883637,
          },
          {
            index: 18,
            value: 147816443,
          },
          {
            index: 19,
            value: 147282655,
          },
          {
            index: 20,
            value: 35175480,
          },
          {
            index: 21,
            value: 201417623,
          },
          {
            index: 22,
            value: 133804378,
          },
          {
            index: 23,
            value: 220701139,
          },
          {
            index: 24,
            value: 446480622,
          },
          {
            index: 25,
            value: 112066737,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Kendrab23',
        opponentScore: 8952,
        secrets: [
          {
            index: 0,
            value: 95584993,
          },
          {
            index: 1,
            value: 407859644,
          },
          {
            index: 2,
            value: 347905634,
          },
          {
            index: 3,
            value: 191726795,
          },
          {
            index: 4,
            value: 516102442,
          },
          {
            index: 5,
            value: 193352771,
          },
          {
            index: 6,
            value: 201701543,
          },
          {
            index: 7,
            value: 512147152,
          },
          {
            index: 8,
            value: 194772519,
          },
          {
            index: 9,
            value: 96407327,
          },
          {
            index: 10,
            value: 77159240,
          },
          {
            index: 11,
            value: 362805862,
          },
          {
            index: 12,
            value: 47646017,
          },
          {
            index: 13,
            value: 93950793,
          },
          {
            index: 14,
            value: 230357628,
          },
          {
            index: 15,
            value: 160603062,
          },
          {
            index: 16,
            value: 139227592,
          },
          {
            index: 17,
            value: 190883637,
          },
          {
            index: 18,
            value: 147816443,
          },
          {
            index: 19,
            value: 147282655,
          },
          {
            index: 20,
            value: 35175480,
          },
          {
            index: 21,
            value: 201417623,
          },
          {
            index: 22,
            value: 133804378,
          },
          {
            index: 23,
            value: 220701139,
          },
          {
            index: 24,
            value: 446480622,
          },
          {
            index: 25,
            value: 112066737,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Neer',
        opponentScore: 30058,
        secrets: [
          {
            index: 0,
            value: 125160682,
          },
          {
            index: 1,
            value: 5104278,
          },
          {
            index: 2,
            value: 34295493,
          },
          {
            index: 3,
            value: 329788648,
          },
          {
            index: 4,
            value: 444270873,
          },
          {
            index: 5,
            value: 118458232,
          },
          {
            index: 6,
            value: 124331470,
          },
          {
            index: 7,
            value: 12689394,
          },
          {
            index: 8,
            value: 532389681,
          },
          {
            index: 9,
            value: 397134716,
          },
          {
            index: 10,
            value: 191086675,
          },
          {
            index: 11,
            value: 213630840,
          },
          {
            index: 12,
            value: 39747735,
          },
          {
            index: 13,
            value: 319138638,
          },
          {
            index: 14,
            value: 428323766,
          },
          {
            index: 15,
            value: 128109073,
          },
          {
            index: 16,
            value: 494180609,
          },
          {
            index: 17,
            value: 319824335,
          },
          {
            index: 18,
            value: 273583050,
          },
          {
            index: 19,
            value: 139914057,
          },
          {
            index: 20,
            value: 191342411,
          },
          {
            index: 21,
            value: 506623648,
          },
          {
            index: 22,
            value: 341288729,
          },
          {
            index: 23,
            value: 232121262,
          },
          {
            index: 24,
            value: 360741129,
          },
          {
            index: 25,
            value: 29356977,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Chr Chr',
        opponentScore: 4966,
        secrets: [
          {
            index: 0,
            value: 202320243,
          },
          {
            index: 1,
            value: 40580155,
          },
          {
            index: 2,
            value: 303462635,
          },
          {
            index: 3,
            value: 447437508,
          },
          {
            index: 4,
            value: 421776322,
          },
          {
            index: 5,
            value: 323025721,
          },
          {
            index: 6,
            value: 104217696,
          },
          {
            index: 7,
            value: 444433452,
          },
          {
            index: 8,
            value: 395552932,
          },
          {
            index: 9,
            value: 145203775,
          },
          {
            index: 10,
            value: 130665701,
          },
          {
            index: 11,
            value: 316658854,
          },
          {
            index: 12,
            value: 487731405,
          },
          {
            index: 13,
            value: 150836824,
          },
          {
            index: 14,
            value: 184591275,
          },
          {
            index: 15,
            value: 204615275,
          },
          {
            index: 16,
            value: 315459885,
          },
          {
            index: 17,
            value: 477625954,
          },
          {
            index: 18,
            value: 150921534,
          },
          {
            index: 19,
            value: 249300770,
          },
          {
            index: 20,
            value: 328199192,
          },
          {
            index: 21,
            value: 127337437,
          },
          {
            index: 22,
            value: 287382473,
          },
          {
            index: 23,
            value: 12007501,
          },
          {
            index: 24,
            value: 475763903,
          },
          {
            index: 25,
            value: 476333137,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'holik',
        opponentScore: 6158,
        secrets: [
          {
            index: 0,
            value: 201719063,
          },
          {
            index: 1,
            value: 521938101,
          },
          {
            index: 2,
            value: 354904106,
          },
          {
            index: 3,
            value: 256236196,
          },
          {
            index: 4,
            value: 356678381,
          },
          {
            index: 5,
            value: 495025218,
          },
          {
            index: 6,
            value: 434570718,
          },
          {
            index: 7,
            value: 205468870,
          },
          {
            index: 8,
            value: 388398061,
          },
          {
            index: 9,
            value: 499080768,
          },
          {
            index: 10,
            value: 404120992,
          },
          {
            index: 11,
            value: 176748322,
          },
          {
            index: 12,
            value: 283533611,
          },
          {
            index: 13,
            value: 374371483,
          },
          {
            index: 14,
            value: 302727323,
          },
          {
            index: 15,
            value: 368030843,
          },
          {
            index: 16,
            value: 110569862,
          },
          {
            index: 17,
            value: 160771979,
          },
          {
            index: 18,
            value: 141181002,
          },
          {
            index: 19,
            value: 8308022,
          },
          {
            index: 20,
            value: 285352940,
          },
          {
            index: 21,
            value: 299367432,
          },
          {
            index: 22,
            value: 507858542,
          },
          {
            index: 23,
            value: 41525300,
          },
          {
            index: 24,
            value: 17544336,
          },
          {
            index: 25,
            value: 181474281,
          },
        ],
      },
    },
  },
  {
    status: 200,
    body: {
      status: 200,
      msg: 'Practice round',
      data: {
        opponentName: 'Chr Chr',
        opponentScore: 4966,
        secrets: [
          {
            index: 0,
            value: 202320243,
          },
          {
            index: 1,
            value: 40580155,
          },
          {
            index: 2,
            value: 303462635,
          },
          {
            index: 3,
            value: 447437508,
          },
          {
            index: 4,
            value: 421776322,
          },
          {
            index: 5,
            value: 323025721,
          },
          {
            index: 6,
            value: 104217696,
          },
          {
            index: 7,
            value: 444433452,
          },
          {
            index: 8,
            value: 395552932,
          },
          {
            index: 9,
            value: 145203775,
          },
          {
            index: 10,
            value: 130665701,
          },
          {
            index: 11,
            value: 316658854,
          },
          {
            index: 12,
            value: 487731405,
          },
          {
            index: 13,
            value: 150836824,
          },
          {
            index: 14,
            value: 184591275,
          },
          {
            index: 15,
            value: 204615275,
          },
          {
            index: 16,
            value: 315459885,
          },
          {
            index: 17,
            value: 477625954,
          },
          {
            index: 18,
            value: 150921534,
          },
          {
            index: 19,
            value: 249300770,
          },
          {
            index: 20,
            value: 328199192,
          },
          {
            index: 21,
            value: 127337437,
          },
          {
            index: 22,
            value: 287382473,
          },
          {
            index: 23,
            value: 12007501,
          },
          {
            index: 24,
            value: 475763903,
          },
          {
            index: 25,
            value: 476333137,
          },
        ],
      },
    },
  },
];
